import { FC } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from '@mui/material';
import { useState } from 'react';

export interface ConfirmationOptions<T> {
    catchOnCancel?: boolean;
    variant: 'danger' | 'info' | 'other';
    title: string;
    fullWidth?: boolean;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    customComplete?: boolean;
    content?:
        | string
        | JSX.Element
        | ((
              resolve: (value?: T) => unknown,
              reject: () => unknown,
              setValue?: (value: T) => void,
              value?: T
          ) => JSX.Element);
}

interface ConfirmationDialogProps<T> extends ConfirmationOptions<T> {
    open: boolean;
    onSubmit: (value?: T) => void;
    onClose: () => void;
}

export const ConfirmationDialog: FC<ConfirmationDialogProps<unknown>> = ({
    open,
    title,
    variant,
    content,
    customComplete = false,
    fullWidth,
    maxWidth,
    onSubmit,
    onClose
}) => {
    const [value, setValue] = useState(undefined);
    const handleOkClick = () => {
        onSubmit(value);
        setValue(undefined);
    };

    return (
        <Dialog open={open} fullWidth={fullWidth ? true : false} maxWidth={maxWidth}>
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent>
                {typeof content === 'string' ? (
                    <DialogContentText>{content}</DialogContentText>
                ) : typeof content === 'function' ? (
                    content(onSubmit, onClose, setValue, value)
                ) : (
                    content
                )}
            </DialogContent>
            <DialogActions>
                <>
                    {!customComplete && (
                        <Button color="primary" title="Ok" onClick={handleOkClick}>
                            OK
                        </Button>
                    )}
                    {variant === 'danger' && (
                        <Button
                            color="primary"
                            onClick={() => {
                                onClose();
                                setValue(undefined);
                            }}
                            title="Cancel"
                            autoFocus>
                            CLOSE
                        </Button>
                    )}
                </>
            </DialogActions>
        </Dialog>
    );
};
